module.exports = __webpack_public_path__ + "img/stretch--genre4_title--sp.103a4388.png";